import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'

import { RangeCalendar, Calendar } from "./Calendars.js"

export default class DateModal extends React.Component {
  static get propTypes () {
    return {
      fromDate: PropTypes.object,
      toDate: PropTypes.object,
      type: PropTypes.string,
      handleToDateSelect: PropTypes.func,
      handleFromDateSelect: PropTypes.func
    }
  }

  constructor (props) {
    super(props)

    this.state = {

      focusDate : moment()
    }
  }

  render () {
    var { fromDate, toDate } = this.props 
    var focusMonth = fromDate || moment() 
    var selecting = this.props.type

    return (
      <div className="fdn-calendar-dropdown-block"
        data-uk-dropdown="mode: click; pos: bottom-right;">

        <div className="date-range">
          { this.props.type === "to" ? 
              <RangeCalendar focusDate={focusMonth}
                fromDate={fromDate}
                toDate={toDate}
                selecting={selecting}
                handleToSelect={this.props.handleToDateSelect}
                handleFromSelect={this.props.handleFromDateSelect}
              />
              : 
              <Calendar focusDate={focusMonth}
                selected={fromDate}
                handleDateSelect={this.props.handleFromDateSelect}
              />
          }
        </div>
      </div>
    )
  }
}

